module.exports = __webpack_public_path__ + "img/Step1.834fead.svg";